import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';
import { useRequest } from 'hooks';

import Show from 'components/Show';
import Editor from 'components/Editor';
import { Form, File, Input, Button } from 'components/Misc/Form';

import { useMaterialProfileStore } from 'store/material/useMaterialProfileStore';

// https://video2.abby.lv/upload/KURSI_LTPC_02/TVI1/02.07.2022/Tīmekļa lapu projektēšana un veidošana.mp4
const Content = ({ tab, setTab }) => {
	// Cache current material's id
	const { id } = useParams();

	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Use material's profile store	
	const [original, onUpdate] = useMaterialProfileStore(state => [
		state.material,
		state.onUpdate
	]);

	// Store material's data
	const [material, setMaterial] = useState({
		content: '',
		video: '',
		file: ''
	});

	// Store request
	const [[progress], request] = useRequest('put', `materials/${id}`);

	// Handle input value change
	const onChange = ({ name, value }) => {
		setMaterial(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async event => {
		event.preventDefault();

		// Do not allow update if in progress or not editable
		if (progress || !original.editable) return;

		// Try to update material's data
		const [success, error] = await request(material, { related: 'content' });

		// Update material's data
		if (success) return onUpdate(material);

		// TODO: Think of a better way of handling errors
		if (error) console.log(error);
	};

	// Initialize material's content
	useEffect(() => {
		if (original) setMaterial(prev => ({
			...prev,
			content: original.content,
			video: original.video,
			file: original.file
		}));
	}, [original]);

	return (
		<Form
			onSubmit={onSubmit}
			className="mt-4 p-4 flex flex-col gap-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			{/* Video url input */}
			<Show if={original.type === 'video'}>
				<Input
					type="text"
					name="video"
					placeholder=" "
					label="Saite"
					value={material.video}
					onChange={onChange}
				/>
			</Show>
			
			{/* Show file preview */}
			<Show if={original.type === 'file'}>
				<File
					name="file"
					path="materials"
					label="Fails"
					folder={original.slug}
					value={material.file}
					onChange={onChange}
				/>
			</Show>

			{/* Show document preview */}
			<Editor
				type="material"
				name="content"
				path="materials"
				label={original.type === 'document' ? undefined : 'Apraksts'}
				readOnly={!original.editable}
				folder={original.slug}
				value={material.content}
				onChange={onChange}
				quiz={{
					mode: 'edit'
				}}
			/>

			{/* Allow to submit only if editable */}
			<Show if={original.editable}>
				<div className="flex justify-end">
					<Button
						submit
						icon="done"
						value="Saglabāt"
						theme="success"
						progress={progress}
					/>
				</div>
			</Show>
		</Form>
	);
};

export default Content;